import { request } from "./http";

export const adminService = {
  getCompanies() {
    return request("/Admin/companies");
  },

  getStatistics() {
    return request("/Admin/statistics");
  },

  updatePaymentStatus(companyId, hasPaid) {
    return request(`/Admin/companies/${companyId}/payment-status`, {
      method: "PUT",
      body: {
        companyId,
        hasPaid: !!hasPaid,
      },
    });
  },

  deleteCompany(id) {
    return request(`/Admin/companies/${id}`, { method: "DELETE" });
  },

  getSalesUsers() {
    return request("/Admin/sales-users");
  },

  createSalesUser(dto) {
    return request("/Admin/sales-users", {
      method: "POST",
      body: dto,
    });
  },

  updateSalesUser(id, dto) {
    return request(`/Admin/sales-users/${id}`, {
      method: "PUT",
      body: dto,
    });
  },

  deleteSalesUser(id) {
    return request(`/Admin/sales-users/${id}`, {
      method: "DELETE",
    });
  },
};
